import userStore from "~/store/userStore";

export function useUserStore() {
  return userStore;
}
